import React, { useEffect } from "react";
import { isAndroid, isIOS } from "react-device-detect";

import HeroSection from "../../components/HeroSection/HeroSection";
import Navbar from "../../components/Navbar/Navbar";

import { downloadObject } from "./Data";

function App() {
  useEffect(() => {
    if (isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=jp.workom";
    } else if (isIOS) {
      window.location.href =
        "https://apps.apple.com/jp/app/workom-%E6%96%B0%E3%81%97%E3%81%84%E5%8C%BF%E5%90%8Dsns%E3%81%A7%E7%A4%BE%E4%BC%9A%E4%BA%BA%E3%81%A8%E4%BA%A4%E6%B5%81%E3%81%97%E3%82%88%E3%81%86/id1601043751?itsct=apps_box_link&itscg=30200";
    } else {
      window.location.href = "https://www.workom.jp";
    }
  }, []);

  return (
    <>
      <Navbar />
      <HeroSection {...downloadObject} />
    </>
  );
}

export default App;
